export default "__VITE_ASSET__DboOzmZX__"